// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260420-0/static/css/" + chunkId + "." + {"2395":"53c8aa17","2425":"53c8aa17","2844":"53c8aa17","2865":"20e73774","2918":"20e73774","2982":"07a465cd","3958":"20e73774","4767":"53c8aa17","7010":"20e73774"}[chunkId] + ".chunk.css";
};